import { render, staticRenderFns } from "./MotivosIntrahopitalario.vue?vue&type=template&id=7195f9c0&scoped=true"
import script from "./MotivosIntrahopitalario.vue?vue&type=script&lang=js"
export * from "./MotivosIntrahopitalario.vue?vue&type=script&lang=js"
import style0 from "./MotivosIntrahopitalario.vue?vue&type=style&index=0&id=7195f9c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7195f9c0",
  null
  
)

export default component.exports